<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_files"
        :show-buttons="false"
        title="Vertragsdokumente">
        <csp-firm-files editable :firm-id="firmId"/>
    </csp-desktop-info-card>
</template>

<script>
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    export default {
        name: 'FirmFiles',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            firmId() {
                return parseInt(this.$route.params.firmId);
            },
        },
    }
</script>
